<template>
  <date-pick
    @input="updateSelectedData"
    :is-date-disabled="checkDate"
    v-model="date"
    :hasInputElement="false"
    :weekdays="calendarWeekDays"
    :months="MONTHS"
    :format="'DD.MM.YYYY'"
  ></date-pick>
</template>

<script>
import DatePick from "vue-date-pick";

import {
  WEEKS,  // short week day names. 0 - Sunday
  WEEKS_LONG,  // long week day names. 0 - Sunday
  MONTHS,
  AVAILABLE_TIMES
} from "@/constants/calendar";
import { toRUDate } from '@/utilities';


// TODO: not used?
let date = new Date();


export default {
  name: "VCalendar",

  components: {
    DatePick
  },

  props: {
    selectedDate: {
      type: [String, Date],
      // TODO: hell
      default: function() {
        return toRUDate(new Date());
      },
    },

    availableDates: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      date: this.selectedDate,
      MONTHS
    };
  },

  computed: {
    // TODO: can't we have `this.date` as a Date object?
    toDate() {
      return new Date(this.date.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3"));
    },

    /**
     * WEEKS - starts with Sunday but we need Monday
     */
    calendarWeekDays() {
      let dayNames = WEEKS.slice(1);
      dayNames.push(WEEKS[0]);
      return dayNames;
    },
  },

  watch: {
    selectedDate(v) {
      this.date = v;
    }
  },

  mounted() {
    this.updateSelectedData();
  },

  methods: {
    checkDate(d) {
      let toStringDate = toRUDate(d);
      return this.availableDates ? !this.availableDates[toStringDate] : false;
    },

    updateSelectedData() {
      this.$emit("update", {
        row: this.toDate,
        day: this.toDate.toLocaleString("ru", {
          month: "long",
          day: "numeric"
        }),
        date: this.date,
        weekDayLong: WEEKS_LONG[this.toDate.getDay()].toLowerCase(),
        weekDay: WEEKS[this.toDate.getDay()]
      });
    }
  }
};
</script>
